module.exports = __webpack_public_path__ + "img/상수 카페.f460cc68.png";